import { __assign, __extends, __rest } from "tslib";
import React from 'react';
import { ThemeContext } from '@skbkontur/react-ui/lib/theming/ThemeContext';
import { getAddonsTheme } from '../../lib/theming/ThemeHelpers';
import { TopBarItem } from './TopBarItem';
import { jsStyles } from './TopBar.styles';
/**
 * Интерактивный элемент топбара
 *
 * @visibleName TopBar.ButtonItem
 */

var TopBarButtonItem =
/** @class */
function (_super) {
  __extends(TopBarButtonItem, _super);

  function TopBarButtonItem() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  TopBarButtonItem.prototype.render = function () {
    var _this = this;

    return React.createElement(ThemeContext.Consumer, null, function (theme) {
      _this.theme = getAddonsTheme(theme);
      return React.createElement(ThemeContext.Provider, {
        value: _this.theme
      }, _this.renderMain());
    });
  };

  TopBarButtonItem.prototype.renderMain = function () {
    var _a = this.props,
        onClick = _a.onClick,
        children = _a.children,
        onKeyDown = _a.onKeyDown,
        rest = __rest(_a, ["onClick", "children", "onKeyDown"]);

    return React.createElement(TopBarItem, __assign({}, rest, {
      className: jsStyles.button(this.theme),
      _onKeyDown: onKeyDown,
      _onClick: onClick
    }), children);
  };

  TopBarButtonItem.defaultProps = {
    use: 'default'
  };
  return TopBarButtonItem;
}(React.Component);

export { TopBarButtonItem };